import { render, staticRenderFns } from "./TsLockScreen.vue?vue&type=template&id=d6f2a7e2&scoped=true&"
import script from "./TsLockScreen.vue?vue&type=script&lang=js&"
export * from "./TsLockScreen.vue?vue&type=script&lang=js&"
import style0 from "./TsLockScreen.vue?vue&type=style&index=0&id=d6f2a7e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6f2a7e2",
  null
  
)

export default component.exports